import { graphql } from 'react-relay';

export default graphql`
    query headerRootQuery(
        $hasUserId: Boolean!
        $previewKey: String = ""
        $showMarketingMessages: Boolean!
        $fetchMarketingMessagesTransactions: Boolean = false
        $userId: String!
        $userIds: [String]!
        $fetchRegionalInfo: Boolean!
        $fetchTradeNav: Boolean!
        $fetchNav: Boolean!
        $zipCode: String!
    ) {
        viewer {
            ...Header_viewer
        }
    }
`;

export const initialVariables = {
    hasUserId: false,
    previewKey: '',
    fetchMarketingMessagesTransactions: false,
    showMarketingMessages: false,
    fetchRegionalInfo: false,
    fetchTradeNav: false,
    fetchNav: false,
    userId: '',
    userIds: [],
    zipCode: '',
};
